import { useMutation } from '@apollo/client';
import LoadingButton from '@mui/lab/LoadingButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import useSelectedCompany from '../../hooks/useSelectedCompany';
import REQUEST_SURPLUS_WITHDRAWAL from '../../graphql/mutations/request-surplus-withdrawal';
import AccountsListWithAdd from '../bank/AccountsListWithAdd';
import FingoDialog from '../dialogs/FingoDialog';
import useAlertMessage from '../../hooks/useAlertMessage';

const SurplusDialog = ({ open, onClose }) => {
  const [selectedAccount, setSelectedAccount] = useState();
  const selectedCompany = useSelectedCompany();
  const [alertMessage, setAlertMessage] = useAlertMessage();

  const [requestSurplus, { loading }] = useMutation(
    REQUEST_SURPLUS_WITHDRAWAL,
    {
      variables: {
        companyId: selectedCompany.id,
        accountId: selectedAccount?.id,
      },
      awaitRefetchQueries: true,
      onCompleted: (data) => {
        if (data?.requestSurplusWithdrawal?.success) {
          onClose();
          return;
        }
        setAlertMessage({
          severity: 'error',
          message:
            data?.requestSurplusWithdrawal?.message
            || 'No se pudo solicitar el retiro de excedentes',
          show: true,
        });
      },
      onError: () => {
        setAlertMessage({
          severity: 'error',
          message: 'Error al solicitar el retiro de excedentes',
          show: true,
        });
      },
    },
  );

  const handleSubmit = () => {
    if (loading || !selectedAccount) {
      return;
    }
    requestSurplus();
  };

  return (
    <FingoDialog
      open={open}
      handleClose={onClose}
      title="Seleccione la cuenta del banco"
      dialogAlert={alertMessage}
      setDialogAlert={setAlertMessage}
      dialogActionButton={(
        <LoadingButton
          loading={loading}
          onClick={handleSubmit}
          disabled={!selectedAccount || loading}
          id="continue-surplus-withdrawal"
        >
          Continuar
        </LoadingButton>
      )}
    >
      <AccountsListWithAdd
        setSelectedAccountInParent={setSelectedAccount}
        xs={12}
        setCreatingNewAccount={() => {}}
        withSelect
        setDialogAlert={setAlertMessage}
      />
    </FingoDialog>
  );
};

SurplusDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SurplusDialog;
